import Footer from "../components/templates/footer";
import Header from "../components/templates/navbar";
import "../assets/scss/pages/termsCondition.scss";

const PrivacyPolicy = () => {
  return (
    <div>
      <Header />
      <div className="terms-container">
        <h1>Privacy Policy</h1>
        <p>Last updated: January 9, 2025</p>
        <hr />
        <p>
          This Privacy Policy ("Policy") explains how Resumly.AI ("we," "us,"
          "our") collects, uses, shares, and protects user ("you," "your")
          Personal Information when you interact with our website, software, and
          services (collectively, "Services").
        </p>
        <hr />
        <h2>1. Information We Collect</h2>
        <p>We may collect:</p>
        <ul>
          <li>
            <strong>Personal Identifiers:</strong> Name, email address, and
            other contact details.
          </li>
          <li>
            <strong>Uploaded Content:</strong> Resumes, job descriptions, and
            related materials.
          </li>
          <li>
            <strong>Usage Data:</strong> IP address, device type, browser type,
            and interaction data.
          </li>
        </ul>
        <hr />
        <h2>2. How We Use Your Information</h2>
        <p>We use collected information to:</p>
        <ul>
          <li>Provide and improve our Services.</li>
          <li>Train and enhance AI models.</li>
          <li>Communicate with you regarding your account.</li>
          <li>Conduct research and analytics for product development.</li>
        </ul>
        <hr />
        <h2>3. Information Sharing</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>
            <strong>Service Providers:</strong> Third-party vendors supporting
            our operations.
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required by law.
          </li>
          <li>
            <strong>Business Transfers:</strong> As part of a merger or sale of
            assets.
          </li>
        </ul>
        <hr />
        <h2>4. Cookies</h2>
        <p>We use cookies to:</p>
        <ul>
          <li>Authenticate users.</li>
          <li>Analyze usage patterns.</li>
          <li>Deliver personalized experiences.</li>
        </ul>
        <hr />
        <h2>5. Data Security</h2>
        <p>
          We implement reasonable security measures to protect your data.
          However, no method of data transmission or storage is completely
          secure, and we cannot guarantee absolute security.
        </p>
        <hr />
        <h2>6. Children's Privacy</h2>
        <p>
          Our Services are not intended for individuals under 13. We do not
          knowingly collect data from children under this age.
        </p>
        <hr />
        <h2>7. Changes to This Policy</h2>
        <p>
          We may update this Policy from time to time. Changes will be posted on
          this page, with the "last updated" date revised accordingly.
        </p>
        <hr />
        <h2>8. Contact Information</h2>
        <p>
          For questions or concerns about this Policy, contact us at{" "}
          <a href="mailto:hello@resumly.ai">hello@resumly.ai</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
